function disablingCheckbox(checkbox: HTMLInputElement) {
  const targets = checkbox.getAttribute("data-disabling-checkbox-target")?.split(" ");
  const onState = checkbox.getAttribute("data-disabling-checkbox-hide-state") === "true";
  const currentState = checkbox.checked;

  if (!targets) { return; }

  targets.forEach((target) => {
    const targetElement = document.getElementById(target);

    if (!targetElement) { return; }

    if (currentState !== onState) {
      targetElement.style.display = "";
    } else {
      targetElement.style.display = "none";
    }
  });
}

function disablingCheckboxReady() {
  const checkboxes = document.querySelectorAll(".disabling-checkbox");
  checkboxes.forEach((checkbox) => {
    if (!(checkbox instanceof HTMLInputElement)) { return; }

    disablingCheckbox(checkbox);
    checkbox.addEventListener("change", () => {
      disablingCheckbox(checkbox);
    });
  });
}

document.addEventListener("DOMContentLoaded", disablingCheckboxReady);
document.addEventListener("turbo:load", disablingCheckboxReady);
